import React from 'react';
import { useIntl } from 'react-intl';
import { Text, TextType } from 'ui-components/components/text';
import check from './Success_Check.svg';

import messages from './messages';
import style from './style.module.css';
import { FlexColumn } from 'ui-components/components/flex';
import { SimpleModal } from '../../../components/simple-modal';

/**
 * @param {object} props
 * @param {() => void} props.onClose - Function to call when closing the modal
 * @returns {JSX.Element}
 */
export const SuccessModal = ({ onClose }) => {
  const intl = useIntl();

  return (
    <SimpleModal actionMessage={messages.doneButton} headerMessage={messages.modalTitle} onAction={onClose} onClose={onClose}>
      <FlexColumn className={style.content}>
        <img alt={intl.formatMessage(messages.successIconAlt)} className={style['success-icon']} src={check} />
        <Text textType={TextType.H2} value={messages.primaryMessage} />
        <Text textType={TextType.Paragraph} value={messages.secondaryMessage} />
      </FlexColumn>
    </SimpleModal>
  );
};
